import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2079da0b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2079da0b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2079da0b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2079da0b')) {
      api.createRecord('2079da0b', component.options)
    } else {
      api.reload('2079da0b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2079da0b&scoped=true", function () {
      api.rerender('2079da0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dataBoard/index.vue"
export default component.exports